(() => {
  'use strict';
  const observers = new Map();
  function initialize(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const main = section.querySelector('[data-main-image]');
      function photo(url, alt) {
        if (!main || !url) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = url;
        main.alt = alt || '';
      }
      section.querySelectorAll('[data-photo]').forEach(link => {
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          photo(link.dataset.photo, link.dataset.alt);
          section.querySelectorAll('[data-photo]').forEach(el => el.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'true');
        });
      });
      const select = section.querySelector('[data-variant]');
      const add = section.querySelector('[data-add]');
      if (select) select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        section.querySelector('[data-price]').textContent = option.dataset.price;
        const stickyPrice = section.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = option.dataset.price;
        const compare = section.querySelector('[data-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        const unit = section.querySelector('[data-unit-price]');
        unit.textContent = option.dataset.unit || '';
        unit.hidden = !option.dataset.unit;
        add.disabled = !available;
        add.textContent = available ? 'Add to cart' : 'Sold out';
        const quantity = section.querySelector('[name="quantity"]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        quantity.value = quantity.min;
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        if (option.dataset.image) {
          photo(option.dataset.image, option.dataset.alt);
          section.querySelectorAll('[data-photo]').forEach(el => el.removeAttribute('aria-current'));
        }
      });
      const bar = section.querySelector('[data-mobile-buy]');
      const returnButton = section.querySelector('[data-return-product]');
      if (bar && add) {
        let scheduled = false;
        const updateBar = () => {
          scheduled = false;
          bar.hidden = add.getBoundingClientRect().bottom >= 0;
          document.body.classList.toggle('has-mobile-buy', !bar.hidden);
        };
        const scheduleUpdate = () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(updateBar);
        };
        window.addEventListener('scroll', scheduleUpdate, {passive: true});
        window.addEventListener('resize', scheduleUpdate, {passive: true});
        observers.set(section, {disconnect() {
          window.removeEventListener('scroll', scheduleUpdate);
          window.removeEventListener('resize', scheduleUpdate);
        }});
        updateBar();
        returnButton.addEventListener('click', () => {
          section.querySelector('.product-info').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
          (select || add).focus({preventScroll: true});
        });
      }
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-product-section]').forEach(section => {
      observers.get(section)?.disconnect();
      observers.delete(section);
    });
    document.body.classList.remove('has-mobile-buy');
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-header details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
})();
